module.exports = __webpack_public_path__ + "static/media/Logo transparent.6ac373af.png";